/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable class-methods-use-this */
import { DefaultLinkFactory } from '@projectstorm/react-diagrams';
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import BandwidthLinkModel from './BandwidthLinkModel';
import BandwidthLinkWidget from './BandwidthLinkRender';

namespace S {
    export const Keyframes = keyframes`
        from {
            stroke-dashoffset: 24;
        }
        to {
            stroke-dashoffset: 0;
        }
    `;

    // @ts-ignore
    export const Path = styled.path<{ selected: boolean }>`
        fill: none;
        pointer-events: auto;
        cursor: move;
    `;
}

class BandwidthLinkFactory extends DefaultLinkFactory {
  constructor() {
    super('Bandwidth');
  }

  generateModel(): BandwidthLinkModel {
    return new BandwidthLinkModel();
  }

  generateReactWidget(event: any): JSX.Element {
    return <BandwidthLinkWidget link={event.model} diagramEngine={this.engine} />;
  }

  generateLinkSegment(model: BandwidthLinkModel, selected: boolean, path: string) {
    return (
      <S.Path
        className={`${selected ? '' : model.getOptions().isDashed ? 'dashed-line' : ''}`}
        selected={selected}
        stroke={model.getOptions().color}
        strokeWidth={model.getOptions().width}
        d={path}
      />
    );
  }
}

export default BandwidthLinkFactory;
